// Libraries
import React from 'react';

// Supermove
import {Loading, Space, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useQuery, useResponsive, ResponsiveType} from '@supermove/hooks';
import {colors} from '@supermove/styles';

// App
import SkeletonLoader from '@shared/design/components/SkeletonLoader';
import MoveProjectsTabContent from 'modules/Project/List/components/MoveProjectsTabContent';

const PageContainer = Styled.View`
  flex: 1;
  background-color: ${colors.gray.background};
`;

const LoadingComponentContainer = Styled.View<{responsive: ResponsiveType}>`
  padding-vertical: 16px;
  padding-horizontal: ${({responsive}) => (responsive.desktop ? 24 : 16)}px;
`;

const Row = Styled.View`
  flex-direction: row;
`;

const LoadingComponent = () => {
  const responsive = useResponsive();

  if (responsive.desktop) {
    return (
      <LoadingComponentContainer responsive={responsive}>
        <Row>
          <SkeletonLoader height={SkeletonLoader.HEIGHT.Button} style={{flex: 1}} />
          <Space width={16} />
          <SkeletonLoader height={SkeletonLoader.HEIGHT.Button} width={100} />
        </Row>
        <Space height={16} />
        <SkeletonLoader height={400} isFullWidth />
      </LoadingComponentContainer>
    );
  }

  return (
    <LoadingComponentContainer responsive={responsive}>
      <Row>
        <SkeletonLoader height={SkeletonLoader.HEIGHT.ButtonMobile} style={{flex: 1}} />
        <Space width={16} />
        <SkeletonLoader height={SkeletonLoader.HEIGHT.ButtonMobile} width={80} />
      </Row>
      <Space height={16} />
      <SkeletonLoader height={120} isFullWidth />
      <Space height={16} />
      <SkeletonLoader height={120} isFullWidth />
      <Space height={16} />
      <SkeletonLoader height={120} isFullWidth />
    </LoadingComponentContainer>
  );
};

const MoveProjectsTab = () => {
  const {loading, data} = useQuery(MoveProjectsTab.query, {
    fetchPolicy: 'cache-and-network',
  });

  return (
    <PageContainer>
      <Loading loading={loading} as={LoadingComponent}>
        {() => {
          return (
            <MoveProjectsTabContent
              organization={data.viewer.viewingOrganization}
              PageLoadingComponent={LoadingComponent}
            />
          );
        }}
      </Loading>
    </PageContainer>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
MoveProjectsTab.query = gql`
  ${MoveProjectsTabContent.fragment}

  query MoveProjectsTab {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
        ...MoveProjectsTabContent
      }
    }
    jobRequestCounter {
      new
    }
  }
`;

export default MoveProjectsTab;
